<template>
	<nav class="menu-panel bell-menu-panel" @mousedown="stopEvent" @click="stopEvent">
		<notification-view v-for="n in notifications" :notification="n" :closeable="false" :panel="false"></notification-view>
	</nav>
</template>

<script setup lang="ts">
import type {Notification} from "@t/meta/Notification.ts";
import NotificationView from "@/notifications/NotificationView.vue";

const props = defineProps<{
	notifications: Notification[]
}>();

/**
 * Stop event bubbling to prevent root element loosing focus
 */
function stopEvent(e:MouseEvent) {
	e.stopPropagation();
}

</script>

<style>
.menu-panel.bell-menu-panel {
	max-width: 318px;
	max-height: calc(100vh - 60px);
	overflow-y: auto;
}
.bell-menu-panel > .notification-view {
	border-top: 1px solid var(--menu-separator-color);
}
.bell-menu-panel > .notification-view:first-child {
	border-top: none;
}
</style>